// Mobile Drawer Toggle
function toggleMobileDrawer() {
  document
    .getElementsByClassName("MobileMenuToggle2")[0]
    .classList.toggle("is-active");
  document.getElementsByClassName("NavList")[0].classList.toggle("is-active");
}

// Header sticky on scroll
let scrollpos = window.scrollY;

const header = document.querySelector("header .Navigation");
const scrollChange = 1;

const add_class_on_scroll = () => header.classList.add("large-navigation");
const remove_class_on_scroll = () =>
  header.classList.remove("large-navigation");

window.addEventListener("scroll", function () {
  scrollpos = window.scrollY;

  if (scrollpos >= scrollChange) {
    remove_class_on_scroll();
  } else {
    add_class_on_scroll();
  }
});

// Custom Popup
// Set this to true to re-enable the holiday popup; false keeps it disabled.
const CUSTOM_POPUP_ENABLED = false;

window.addEventListener("load", function () {
  if (!CUSTOM_POPUP_ENABLED) return;

  // if query string contains ?test-custom-popup=true, always show the popup
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("test-custom-popup")) {
    showCustomPopup();
    return;
  }

  const now = new Date().getTime();

  // display the popup at most once every 3 days
  const lastClosed = localStorage.getItem("custom-popup-closed");

  if (!lastClosed) {
    showCustomPopup();
    return;
  }

  const diff = now - parseInt(lastClosed);
  const days = diff / (1000 * 60 * 60 * 24);

  if (days > 3) {
    showCustomPopup();
  }
});

const hideCustomPopup = () => {
  const now = new Date().getTime();
  localStorage.setItem("custom-popup-closed", now);
  localStorage.setItem("custom-popup-last-action", "close");
  document.getElementById("custom-popup").classList.remove("active");
};

const showCustomPopup = () => {
  document.getElementById("custom-popup").classList.add("active");
};
